import { Action } from '@ngrx/store';
import { ActionTypes } from '../../../core/models/actionTypes';
import { MatchmackingId } from '../interfaces/matchmaking-id';

export const MatchmakingIdAction = (matchmakingId: MatchmackingId) => {
  return <Action>{ type: ActionTypes.MatchmakingId, payload: matchmakingId };
};
